import { render, staticRenderFns } from "./TypeInstrument.vue?vue&type=template&id=c8c61a7c&"
import script from "./TypeInstrument.vue?vue&type=script&lang=js&"
export * from "./TypeInstrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports